module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921105649_T.d2510d68.jpg";